import HeroCarousel from "@/pages/home/components/HeroCarousel";
import QuickEntries from "@/pages/home/components/QuickEntries";
import LatestSection from "@/pages/home/components/LatestSection";
import HotRanking from "@/pages/home/components/HotRanking";
import NewsPreview from "@/pages/home/components/NewsPreview";
import FavoritesShelf from "@/pages/home/components/FavoritesShelf";
import AboutBrief from "@/pages/home/components/AboutBrief";
import SiteLayout from "@/components/feature/SiteLayout";
import { usePageTitle } from "@/hooks/usePageMeta";
import { titles } from "@/utils/catalog";

export default function Home() {
  usePageTitle(
    "CC视频—专业影视视频平台，电影电视剧在线观看",
    "CC视频为用户提供丰富的影视视频内容，包括最新电影和热门电视剧，方便在线观看和资讯浏览。致力于打造专业影视娱乐平台，满足各类观影需求。",
  );

  const heroItems = titles.filter((t) =>
    ["deep-blue-line", "shadow-division", "spring-on-the-plateau", "future-perfect"].includes(t.id),
  );

  return (
    <SiteLayout>
      <HeroCarousel items={heroItems} />
      <QuickEntries />
      <LatestSection />
      <HotRanking />
      <NewsPreview />
      <FavoritesShelf />
      <AboutBrief />
    </SiteLayout>
  );
}